module.exports = __webpack_public_path__ + "static/6-Podium-Landscape-view-eye-level-02-c63c14051e474eabb071bf5e1e3f6878.jpg";